import { render, staticRenderFns } from "./detail-in-table-list.vue?vue&type=template&id=638978ac&"
import script from "./detail-in-table-list.vue?vue&type=script&lang=js&"
export * from "./detail-in-table-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports